import { DOCUMENT } from '@angular/common';
import {
  ApplicationRef,
  createComponent,
  Injectable,
  inject,
} from '@angular/core';
import { Observable, race, take } from 'rxjs';
import {
  ModalConfirmComponent,
  ModalConfirmData,
} from '../modals/modal-confirm/modal-confirm.component';

export class ModalConfirmRef {
  readonly isConfirmed: Observable<boolean>;

  constructor(_isConfirmed: Observable<boolean>) {
    this.isConfirmed = _isConfirmed;
  }
}

@Injectable({
  providedIn: 'root',
})
export class ModalConfirmService {
  private appRef = inject(ApplicationRef);
  private _document = inject<Document>(DOCUMENT);

  open(data: ModalConfirmData): ModalConfirmRef {
    // Create or use host element
    let hostElement = this._document.getElementById('ss-modal-confirm');
    if (!hostElement) {
      hostElement = this._document.createElement('div');
      hostElement.setAttribute('id', 'ss-modal-confirm');
      this._document.body.appendChild(hostElement);
    }

    const confirmRef = createComponent(ModalConfirmComponent, {
      environmentInjector: this.appRef.injector,
      hostElement,
    });

    // Set the inputs of the modal

    // Default the modal to open
    confirmRef.instance.openModal = true;

    // Allow confirm specific options to be set
    confirmRef.instance.setOptions(data);

    // Listen for the close event or confirm event
    // Emit true on confirm, false on close
    const isConfirmed = confirmRef.instance.confirm.pipe(take(1));

    // Destroy the component when the modal is closed
    race(isConfirmed, confirmRef.instance.openModalChange)
      .pipe(take(1))
      .subscribe(() => {
        confirmRef.destroy();
      });

    // Attach the component to the appRef so that it's inside the ng component tree
    this.appRef.attachView(confirmRef.hostView);

    return new ModalConfirmRef(isConfirmed);
  }
}
